module.exports = __webpack_public_path__ + "img/image_22.90c9af1b.png";